import React from 'react';

import classNames from 'classnames';

import useFormFields from '../../../../../Form/CrudForm/hooks/useFormFields';

export default function SubFields({ subFields, formik, depth = 1, row }) {
  const renderedSubfields = useFormFields(subFields || [], formik);

  if (!subFields || subFields.length === 0) {
    return null;
  }

  return (
    <ul
      style={{ paddingLeft: `${depth * 20}px` }}
      className={classNames('flex gap-4', {
        'flex-col': !row,
        'flex-col items-start md:flex-row': row,
      })}
    >
      {subFields.map((field, index) => {
        return (
          <li key={field.name}>
            {renderedSubfields[index]}
            {field.subFields && formik.values[field.name] && (
              <SubFields
                row={row}
                subFields={field.subFields}
                formik={formik}
                depth={depth + 1}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
}
